export const DEFAULT_DASHBOARD_GRID_PAGE_SIZE = 20;
